<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">update employee</small>
      </legend>
      <div>
        <form @submit.prevent="employeeUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="employeeId" :value="Employee.id" />
              <div class="form-group">
                <label>Employee names</label>
                <input
                  type="text"
                  class="form-control employee_name"
                   :value="Employee.employee_name"
                  placeholder="employee name"
                  required
                />
              </div>
            
               <div class="form-group">
                <label>Employee status</label>
                <select name="status" class="form-control status" :value="Employee.status" required>
                  <option value>select status</option>
                  <option value="0">Inactive</option>
                  <option value="1">Active</option>
                </select>
              </div>
              <div class="form-group">
                <label>Occupation</label>
                <select
                  name="occupation"
                  class="form-control occupation_id"
                  required
                  :value="Employee.occupation_id"
                >
                  <option value>select occupation</option>
                  <option
                    v-for="occupation in systemOccupations"
                    :key="occupation.id"
                    :value="occupation.id"
                  >
                    {{ occupation.occupation_name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>Salary</label>
                <input
                  type="number"
                  class="form-control salary"
                  placeholder="salary"
                  min="1"
                  step=".01"
                  :value="Employee.salary"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Id number</label>
                <input
                  type="number"
                  class="form-control id_no"
                  :value="Employee.id_no"
                  placeholder="id no"
                  required
                />
              </div>
              <div class="form-group">
                <label>gender</label>
                <select name="gender" class="form-control gender" :value="Employee.gender" required>
                  <option value>select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div class="form-group">
                <label>Phone number</label>
                <input
                  type="text"
                  class="form-control phone_no"
                  :value="Employee.phone_no"
                  placeholder="phone no"
                  required
                />
              </div>
            

            </div>
          </div>
           <button type="submit" class="btn btn-primary btn-flat updatingEmployee">
            <i class="fa fa-refresh"></i> update employee
          </button>
          <button type="button" class="btn btn-info btn-flat updatingEmployeeLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index"
export default {
  created() {
    if (this.$store.getters.Employee.length === 0) {
      router.push("/manageemployees");
    }
    this.loadOccupations();
 
  },
  computed: {
    ...mapGetters(["Employee","systemOccupations"])
  },

  methods: {
    ...mapActions(["employeeUpdate", "loadOccupations"])
  }
};
</script>
<style scoped>
.updatingEmployeeLoader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/employees/updateemployee.vue